module.exports = __webpack_public_path__ + "static/bird1-0f8c09dbc8f1e48d5c910d4d91ec843f.png";